export default __webpack_public_path__ + "static/media/Learner.26c6adeb.png";